export default __webpack_public_path__ + "static/media/mc-2-rMIN.f9d57927.avif";